/**
 * @author wangyingxu1
 * request
 */

import axios from 'axios';
import {
  IRequestParams,
  IAxiosParams,
  IResolveData,
  IDefaultHeaders
} from './inferface';
import { Message } from 'element-ui';
import { domainMap } from '@/config';
import { logout } from '@/util';

const request = ({
  domainKey = 'base',
  url = '',
  method = 'get',
  headers = {},
  data = {},
  timeout = 10000,
  errorMsg = '接口发生错误，请重试'
}: IRequestParams): any => {
  if (!url || !method) {
    Message({
      message: '检查请求',
      type: 'error',
      duration: 2000
    });
    return Promise.reject('检查请求');
  }
  const defaultHeaders: IDefaultHeaders = {
    'content-type': 'application/json'
  };

  let config: IAxiosParams = {
    url: `${domainMap[domainKey]}${url}`,
    method,
    headers: {
      ...defaultHeaders,
      ...headers
    },
    timeout,
    params: {},
    data: {},
    withCredentials: true
  };
  if (method === 'get') {
    config = {
      ...config,
      params: data
    };
    delete config.data;
  } else {
    config = {
      ...config,
      data
    };
    delete config.params;
  }

  return axios(config)
    .then((res: any) => { // status === 200
      const { success, status, code, object, result, data: resultData }: IResolveData = res.data;
      if (success || status) {
        if (code === '999') { // 用户未登陆，没有权限
          logout();
          return;
        }
        return Promise.resolve(object || result || resultData);
      }
      return Promise.reject(res);
    })
    .catch((rej: any)  => {
      if (rej.code === 'ECONNABORTED' && rej.isAxiosError) {
        Message.error({
          message: 'TIMEOUT! 请求超时',
          duration: 2000
        });
        return Promise.reject(rej);
      }

      if (rej.response && rej.response.status !== 200) { // 请求失败
        Message.error({
          message: `请求网络错误：${rej.response.status}`,
          duration: 2000
        });
        return Promise.reject(rej.response);
      }

      if (rej.status && rej.status === 200) { // 请求成功 业务失败
        Message.error({
          message: rej.data.message || errorMsg,
          duration: 2000
        });
        return Promise.reject(rej.data);
      }

      return Promise.reject(rej);
    });
};

export default request;
